import { Component } from '@angular/core';
import { GroupValidationBloc } from '@kp/auth/group-validation.bloc';

@Component({
  selector: 'kp-screen-eligibility-selection',
  templateUrl: './screen-eligibility-selection.component.html',
  styleUrls: ['./screen-eligibility-selection.component.scss'],
})
export class ScreenEligibilitySelectionComponent {
  constructor(public groupValidationBloc: GroupValidationBloc) {}
}
